import {
  faPhp,
  faReact,
  faHtml5,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import pcSoft from "./logo-pcsoft-b.png"
const About = () => {

function shuffleCube() {
    const sides = document.querySelectorAll(".side");
    
    sides.forEach(side => {
        let cells = side.querySelectorAll(".cell");
        let shuffledCells = Array.from(cells);
        
        // Mélange des cases sur chaque côté
        shuffledCells = shuffledCells.sort(() => Math.random() - 0.5);
        
        // Appliquer le mélange
        shuffledCells.forEach((cell, index) => {
            side.appendChild(shuffledCells[index]);
        });
    });
}

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              strArray={['Q', 'u', 'i', ' ', 'j', 'e', ' ', 's', 'u', 'i', 's']}
              idx={15}
            />
          </h1>
  
          <p>
          Développeur passionné et autodidacte, je maîtrise le développement et la maintenance d'ERP complexes, 
          ainsi que les outils PC SOFT (WinDev, WinDev Mobile, WebDev), PHP et SQL. 
          J'apprécie particulièrement les projets ambitieux qui me permettent d'apprendre et de me dépasser constamment.
          <a href="/documents/CV_Thomas_Amand.pdf" download > Voir mon CV</a>.
          </p>
        <div className='logos-container'>
          <img alt="PC SOFT" src={pcSoft} className='logos'/>
        </div>
      
        <p align="LEFT">
          Dans mon temps libre, je me plonge dans le développement web via des frameworks comme React, Django et Angular.
          Je suis passionné par les casses tête, en particulier les Rubik's Cube.
        </p>
         
        <div class="cube-container">
          <div class="rubiks-cube">
              <div class="side front">
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
              </div>
              <div class="side back">
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
              </div>
              <div class="side left">
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
              </div>
              <div class="side right">
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
              </div>
              <div class="side top">
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
              </div>
              <div class="side bottom">
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                  <div class="cell"></div><div class="cell"></div><div class="cell"></div>
              </div>
          </div>
      </div>
      </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
